<!-- <section class="our-products-section" [style.background]="company.globalBackGroundColor">
    <p class="products-paragraph">Our Products</p>
    <div class="text-center">
      <img src="../../assets/bhavav.png" class="bhavanimg" alt="" />
    </div>
    <div class="container images-section">
      <div class="row">
        <div class="col-md-3">
          <div class="new-class-for-boder">
            <img src="../../assets/goldbars.png" class="goldbarsimg" alt="" />
          </div>
            <p class="goldbars-paragraph mb-0">Gold Bars</p>
            <p class="text-center mb-0 new-class-for-black">Bank Metal</p>
          <p class="text-center mb-0 new-class-for-black">999 Purity</p>
        </div>

        <div class="col-md-3">
        <div class="new-class-for-boder">
            <img src="../../assets/silverbars.png" class="goldbarsimg" alt="" />
        </div>
         <p class="goldbars-paragraph mb-0">Silver Bars</p>
          <p class="text-center mb-0 new-class-for-black">Bank Metal</p>
          <p class="text-center mb-0 new-class-for-black">999 Purity</p>
        </div>

        <div class="col-md-3">
          <div class="new-class-for-boder">
            <img src="../../assets/goldcoins.png" class="goldbarsimg" alt="" />
          </div>
             <p class="goldbars-paragraph mb-0">Gold Coins</p>
          <p class="text-center mb-0 new-class-for-black">Bank Metal</p>
          <p class="text-center mb-0 new-class-for-black">999 Purity</p>
        </div>

        <div class="col-md-3">
          <div class="new-class-for-boder">
            <img src="../../assets/silvercoins.png" class="goldbarsimg" alt="" />
          </div>
           <p class="goldbars-paragraph mb-0">Silver Coins</p>
          <p class="text-center mb-0 new-class-for-black">Bank Metal</p>
          <p class="text-center mb-0 new-class-for-black">999 Purity</p>
        </div>
      </div>
    </div>
  </section> -->


  <section class="our-products-section">
  <p class="products-paragraph">Our Products</p>
  <div class="text-center">
    <img src="../../assets/images/bhavav.png.png" class="bhavanimg" alt="" />
  </div>

  <div class="container">
<div class="products-grid">

  <div class="product-card" style="animation-delay: 0.1s;" (click)="goToGoldBarsModal()">
    <div class="card-image-wrap">
      <img src="../../assets/goldbars.png" class="card-img" alt="Gold Bars" />
    </div>
    <p class="card-title">Gold Bars</p>
    <p class="card-subtext mb-0">Bank Metal</p>
    <p class="card-subtext mb-0">999 Purity</p>
  </div>

  <div class="product-card" style="animation-delay: 0.25s;" (click)="goToSilverBarsModal()">
    <div class="card-image-wrap">
      <img src="../../assets/silverbars.png" class="card-img" alt="Silver Bars" />
    </div>
    <p class="card-title">Silver Bars</p>
    <p class="card-subtext mb-0">Bank Metal</p>
    <p class="card-subtext mb-0">999 Purity</p>
  </div>

  <div class="product-card" style="animation-delay: 0.4s;" (click)="goToGoldModal()">
    <div class="card-image-wrap">
      <img src="../../assets/goldcoins.png" class="card-img" alt="Gold Coins" />
    </div>
    <p class="card-title">Gold Coins</p>
    <p class="card-subtext mb-0">Bank Metal</p>
    <p class="card-subtext mb-0">999 Purity</p>
  </div>

  <div class="product-card" style="animation-delay: 0.55s;" (click)="goToSilverModal()">
    <div class="card-image-wrap">
      <img src="../../assets/silvercoins.png" class="card-img" alt="Silver Coins" />
    </div>
    <p class="card-title">Silver Coins</p>
    <p class="card-subtext mb-0">Bank Metal</p>
    <p class="card-subtext mb-0">999 Purity</p>
  </div>

</div>
  </div>
</section>